import { memo } from 'react';

import Button from '@wconcept/wconcept-ui/components/atoms/Button';
import Text from '@wconcept/wconcept-ui/components/atoms/Text';
import { classNameBind } from '@wconcept/wconcept-ui/utils/common';

import * as S from './style';

interface IProps {
  title?: string;
  className?: string;
  $offBgColor: string;
  $onBgColor: string;
  $offTextColor: string;
  $onTextColor: string;
  onClick?: () => void;
  active?: boolean;
}

const EvtNaviItemType2 = ({
  title,
  className,
  onClick,
  $offBgColor,
  $onBgColor,
  $offTextColor,
  $onTextColor,
  active = false,
}: IProps) => {
  const cName = classNameBind([
    'event-navi-item',
    active ? 'active' : '',
    className || '',
  ]);

  const colors = {
    $offBgColor: $offBgColor || '#fff',
    $onBgColor: $onBgColor || '#000',
    $offTextColor: $offTextColor || '#000',
    $onTextColor: $onTextColor || '#fff',
  };

  return (
    <S.EvtNaviItemType2
      className={cName}
      $colors={colors}
      suppressHydrationWarning
    >
      <Button className="area-click" onClick={onClick}>
        <div className="text-box">
          {title ? <Text>{title}</Text> : undefined}
        </div>
      </Button>
    </S.EvtNaviItemType2>
  );
};

export default memo(EvtNaviItemType2);
